import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { checkCondition } from './helpers';
import { IState } from '@/state/IState';
import { ProfilePermissions, PermissionCheck } from '@/types';

const mapStateToProps = (state: IState) => ({ profile: state.global.activeProfile });



type OwnProps = ReturnType<typeof mapStateToProps> & {
    condition: PermissionCheck<ProfilePermissions>;
    fallbackDisplay?: ReactNode;
    children?: ReactNode;
};

const ProfilePermissionToggle: React.FC<OwnProps> = ({ children, profile, condition, fallbackDisplay }) => {
    if (profile && profile.permissions && checkCondition(profile.permissions, condition)) {
        return <>{children}</>;
    }

    return <>{fallbackDisplay || null}</>;
};

export default connect(mapStateToProps)(ProfilePermissionToggle);